
import { helpers } from './helpers';

export const homepage = {
    init: () => {
        console.debug("homepage.js: init");
        // Only run on start page
        if ($('#homepage-wrapper').length) {
            homepage.hideCustomTextAfterScroll();
            homepage.autoScrollReviews();

            /* Pretty prices for recommended products */
            $(".recommended-products-price").each(function (index) {
                $(this).html(homepage.formatNumberWithSpaces($(this).html()));
            });

            homepage.textAnimation();

            // Load different videos based on device
            var videosource = $("#campaign_dpjhomepage_video").attr("videosourcedesktop")
            if (helpers.isSmallDevice()) {
                videosource = $("#campaign_dpjhomepage_video").attr("videosourcemobile");
            }
            $("#campaign_dpjhomepage_video").html(`<video autoplay defaultmuted muted loop playsinline disableRemotePlayback preload="auto" id="campaign_1_video"><source src="${prestashop.urls.base_url}${videosource}" type="video/mp4" id="campaign_1_video_source"></video>`);

            homepage.fadeInAtEndOfVideo();
            homepage.fadeInElements();
            homepage.rollingTextAnimation();
        }

        homepage.initSlidingUnderlineTabs();

    },
    formatNumberWithSpaces: (numberstring) => {
        // Code from stackoverflow
        return numberstring.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
    },
    initSlidingUnderlineTabs: () => {
        $(".slider-tabs-container").each(function () {
            $(this).find(".slider-tab-button-underline").css("width", $(this).find(".slider-tab-button-1").css("width"));
            $(this).find(".slider-tab-button-underline").css("width", $(this).find(".slider-tab-button-1").css("width"));
            $(this).find(".slider-tab-button-underline").css("left", $(this).find(".slider-tab-button-1").position().left + "px");
            // Brute force way to get total width of all the element even when they are not visible becuse of scroll in mobile view
            $(this).find(".slider-tab-button-underline-background").css("width", $(this).find(".slider-tab-button-1").outerWidth() + $(this).find(".slider-tab-button-2").outerWidth() + $(this).find(".slider-tab-button-3").outerWidth() + $(this).find(".slider-tab-button-4").outerWidth() + $(this).find(".slider-tab-button-5").outerWidth() + 15 + "px");

            $(this).find(".slider-tab-button").click(function () {

                $(this).parent().find(".slider-tab-button").each(function (index) {
                    $(this).removeClass("active");
                });
                $(this).parent().parent().parent().find(".slider-tab").each(function (index) {
                    $(this).removeClass("active");
                });
                var openTab = ".slider-tab-" + $(this).attr("class").replace(/\D/g, '');
                $(this).parent().parent().parent().find(openTab).addClass("active");
                $(this).addClass("active");

                $(this).parent().find(".slider-tab-button-underline").css("width", $(this).css("width"));
                $(this).parent().find(".slider-tab-button-underline").css("left", $(this).position().left + $(this).parent().parent().find(".slider-tabs").scrollLeft() + "px");

                window.dispatchEvent(new Event('resize'));
                setTimeout(function () {
                    window.dispatchEvent(new Event('resize'));
                }, 1000);
            });
        });
    },
    autoScrollReviews: () => {
        var AutoScrollDirection = "next"
        setInterval(function () {
            if ($(".dpjhomepage-trustpilot-wrapper .next").css("opacity") == "0") {
                AutoScrollDirection = "prev"
            }
            if ($(".dpjhomepage-trustpilot-wrapper .prev").css("opacity") == "0") {
                AutoScrollDirection = "next"
            }
            $(".dpjhomepage-trustpilot-wrapper ." + AutoScrollDirection).click();
        }, 7000);
    },
    hideCustomTextAfterScroll: () => {
        var originalHeight = $("#index #custom-text").outerHeight() + 100 + "px";
        var userReachedHalfPageHeight = false;
        $(document).scroll(function () {
            if (!userReachedHalfPageHeight && $(document).scrollTop() >= ($(document).outerHeight() / 2)) {
                if (helpers.isSmallDevice()) {
                    $("#index #custom-text").css("height", "410px");
                } else {
                    $("#index #custom-text").css("height", "470px");
                }
                userReachedHalfPageHeight = true;
            }
        });
        $("#index #custom-text, #index .custom-text-read-more").click(function () {
            $("#index #custom-text").css("height", originalHeight);
            $("#index #custom-text").css("cursor", "auto");
            $("#index .custom-text-read-more").css("display", "none");
            $("#index #custom-text").removeClass();
        });
    },
    textAnimation: () => {

        if ($("#campaign_dpjhomepage_animation").length) {
            setInterval(function () {
                if (helpers.isSmallDevice()) {
                    // No mobile support
                    return;
                }
                var animationtext = $("#campaign_dpjhomepage_animation").attr("animationtext").split("#");

                var currentText = "";
                for (let i = 0; i < animationtext.length; i++) {
                    currentText = animationtext[i].replace("&lt;", "<").replace("&gt;", "<");
                    if (currentText != $(".animationtext").html()) {
                        $(".animationtext").fadeOut(function () {
                            $(this).html(currentText).fadeIn();
                        });
                        break;
                    }
                }
            }, 5000);
        }
    },
    fadeInAtEndOfVideo: () => {
        if ($(".home-bg-fade-in").length) {

            const video = document.getElementById('campaign_1_video');
            video.removeAttribute('loop');

            video.addEventListener('ended', () => {
                $(".home-bg-fade-in").css("opacity", "1");
            });


        }
    },
    fadeInElements: () => {
        if ($(".campaign_dpjhomepage_animation_fade_in_text_wrap").length) {
            var a = new Image;

            a.onload = function () {
                setTimeout(function () {
                    $(".home-content-text-splash").addClass("home-content-text-splash-reveal");
                    setTimeout(function () {
                        $(".campaign_dpjhomepage_animation_fade_in_text_wrap").addClass("campaign_dpjhomepage_animation_fade_in_text_wrap_reveal");
                    }, 1000);
                }, 500);
            };

            // image that need to be loaded before fade in
            var backgroundImage = $('.campaign_dpjhomepage_animation_fade_in').css('background-image');
            var backgroundImageUrl = backgroundImage.replace(/^url\(["']?/, '').replace(/["']?\)$/, '');
            a.src = backgroundImageUrl;
        }
    },
    rollingTextAnimation: () => {
        if ($(".rolling-text-animated").length) {
            var rollingSpeed = 1500;
            if (helpers.isSmallDevice()) {
                rollingSpeed = 4000;
            }

            var scrollOffsetRollingText = 0;
            setInterval(function () {
                scrollOffsetRollingText = scrollOffsetRollingText + parseInt($(".rolling-text-animated").css("line-height"));   
                // Reset
                if($(".rolling-text-animated").scrollTop() > 1000){
                    scrollOffsetRollingText = 0;
                }
                $(".rolling-text-animated").animate({ scrollTop: scrollOffsetRollingText }, 400);
            }, rollingSpeed);
        }
    },

}